import { createEmptySliceBase, injectTableSlice, toReducer } from '../sliceFactory';

const createRegionsReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'regions' });
  const withTable = injectTableSlice({ initialSort: 'name', sliceBase });
  return toReducer(withTable);
};

export default createRegionsReducer;
